import { GenericBaseRequest } from 'src/app/core/models/request/generic-base.request';

export class ActivateAccountRequest extends GenericBaseRequest {
  codigo: string;
  description: string = '';
  appVersion: string = '';

  constructor() {
    super();
  }
}
